<template>
  <component :is="appDocumentation" />
</template>

<script>
import { isDocApplication } from '@/utils/app.js'
import Assistant from './Assistant.vue'
import Contract from './Contract.vue'

export default {
  components: {
    Assistant,
    Contract
  },
  computed: {
    appDocumentation () {
      return isDocApplication() ? 'Contract' : 'Assistant'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
